import React, { useState } from 'react'

import {
  Avatar,
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  DatePicker,
  Table,
  Tag,
  Divider,
  Popconfirm
} from 'antd'
import { getAllHeroContract } from '../../modules/hero'
import { deleteLogContract, updatLogContract } from '../../modules/logContract'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import { useDeepEffect } from '../../utils/hooks'
import moment from 'moment'
import 'moment/locale/th'
import locale from 'antd/es/date-picker/locale/th_TH'
import LogContractForm from './LogContractForm'

const initialOptions = {
  page: 0,
  size: 20,
  createdAt: ''
}

const LogContract = ({ form }) => {
  const { validateFields, getFieldDecorator } = form
  const dispatch = useDispatch()
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [filterOption, setFilterOption] = useState(initialOptions)

  const [formData, setFormData] = useState({})
  const [visible, setVisible] = useState(false)

  const { heroLogContractList, isLoading } = useSelector(
    (state) => ({
      heroLogContractList: state.hero.heroLogContractList,
      isLoading: state.hero.isLoading
    }),
    []
  )

  async function fetch() {
    await dispatch(getAllHeroContract(filterOption))
  }

  async function onClick(e, record) {
    e.preventDefault()
    await setFormData(record)
    await setVisible(true)
  }

  async function onDelete(id) {
    await dispatch(deleteLogContract(id))
    await fetch()
  }

  const onCloseModal = () => {
    setVisible(false)
    setFormData({})
  }

  const onOk = async (data) => {
    await dispatch(updatLogContract(data))
    await fetch()
    await setVisible(false)
    await setFormData({})
  }

  useDeepEffect(() => {
    fetch()
  }, [])

  const GetDate = (created) => {
    let date = ''
    if (created !== null) {
      date = moment(created).format('DD/MM/YYYY HH:mm')
    }
    return date
  }

  const columns = [
    {
      title: 'วันที่',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 200,
      render: (createdAt) => {
        const created = GetDate(createdAt)
        return <span>เวลา {created}</span>
      }
    },
    {
      title: 'Hero',
      dataIndex: 'heroName',
      key: 'heroName',
      width: 220,
      render: (name, record) => (
        <Row type="flex" gutter={8}>
          <Col>
            <div>
              <Avatar src={record.heroImage} />
            </div>
          </Col>
          <Col>
            <span>{name}</span>
          </Col>
        </Row>
      )
    },
    {
      title: 'Detail',
      dataIndex: 'note',
      key: 'note'
    },
    {
      title: 'User',
      dataIndex: 'adminName',
      key: 'adminName',
      width: 120,
      render: (name, record) => (
        <Row type="flex" gutter={8}>
          <Col>
            <div>
              <Avatar src={record.adminImage} />
            </div>
          </Col>
          <Col>
            <span>{name}</span>
          </Col>
        </Row>
      )
    },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => onClick(e, record)}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  async function onShowSizeChange(current, pageSize) {
    filterOption.size = pageSize
    setFilterOption(filterOption)
    await dispatch(getAllHeroContract(filterOption))
  }

  async function onChange(page) {
    filterOption.page = page - 1
    setFilterOption(filterOption)
    await dispatch(getAllHeroContract(filterOption))
  }

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        if (values.createdAt) {
          const date = moment(values.createdAt).format('yyyy-MM-DD')
          filterOption.createdAt = date
        } else {
          filterOption.createdAt = ''
        }

        if (values.keyword) {
          filterOption.keyword = '%' + values.keyword + '%'
        } else {
          filterOption.keyword = ''
        }
        filterOption.page = 0
        await dispatch(getAllHeroContract(filterOption))
      }
    })
  }

  async function onClear() {
    filterOption.page = initialOptions.page
    filterOption.size = initialOptions.size
    filterOption.createdAt = ''
    filterOption.keyword = ''
    form.resetFields()
    await dispatch(getAllHeroContract(filterOption))
  }

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys)
    },
    selectedRowKeys: selectedRowKeys
  }

  return (
    <Card
      title="Log Contract"
      extra={
        <div>
          <Button size="small" icon="reload" onClick={() => fetch()}>
            Reload
          </Button>
        </div>
      }>
      <Form onSubmit={onSubmit} layout="inline">
        <Row type="flex" justify="space-between" align="middle">
          <Col>
            <Row type="flex" justify="end" gutter={8} align="middle">
              <Col>
                <Form.Item style={{ margin: 0 }} label="วันที่">
                  {getFieldDecorator(`createdAt`)(
                    <DatePicker
                      format="DD/MM/YYYY"
                      style={{ width: 170 }}
                      locale={locale}
                    />
                  )}
                </Form.Item>
              </Col>
              <Col>
                <Form.Item style={{ margin: 0 }}>
                  {getFieldDecorator(`keyword`)(
                    <Input
                      style={{ width: 200 }}
                      placeholder="ชื่อ Hero/ รายละเอียด/ User"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col>
                <Button type="primary" htmlType="submit">
                  ค้นหา
                </Button>
              </Col>
              <Col>
                <Button type="danger" onClick={() => onClear()}>
                  เคลียร์
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
      <br></br>
      {!isEmpty(heroLogContractList) && (
        <Table
          bordered
          loading={isLoading}
          scroll={{ x: 700 }}
          rowKey={(record) => record.id}
          dataSource={heroLogContractList.content}
          columns={columns}
          pagination={{
            current: heroLogContractList.pageable.pageNumber + 1,
            pageSize: heroLogContractList.size,
            pageSizeOptions: ['10', '20', '50', '100'],
            showSizeChanger: true,
            onShowSizeChange: onShowSizeChange,
            onChange: onChange,
            total: heroLogContractList.totalElements
          }}
        />
      )}
      <LogContractForm
        visible={visible}
        formData={formData}
        onOk={onOk}
        onCancel={onCloseModal}
      />
    </Card>
  )
}

const WrappedLogContract = Form.create({ name: 'LogContract' })(LogContract)
export default WrappedLogContract
